import React from "react";
import SectionContent from "../components/SectionContent";

const About = () => (
	<SectionContent
		title="AboutMe"
		content="Hi, I'm Victor Rios, a software engineer who enjoys building systems that combine user experience, real-time infrastructure, and developer tools. My work focuses on developing scalable web applications and communication platforms, with experience ranging from frontend architecture to telemetry systems and SDK development. I like taking complex technical problems and turning them into reliable, well-designed products, and working with teams to bring ideas from concept to production. Outside of work, I spend time experimenting with developer tools and hardware projects. Customizing my personal dev setup (including Neovim and Linux), building small electronics projects with Raspberry Pi, and exploring new technologies that help me better understand how software works under the hood."
	/>
);

export default About;
